import { createBrowserClient } from "@whistll/shared";
import { env } from "./env";

export const supabase = createBrowserClient({
  url: env.supabaseUrl,
  anonKey: env.supabaseAnonKey,
});
